// see https://github.com/nextui-org/nextui/blob/main/packages/core/theme/src/components/spinner.ts
import { tv } from "@heroui/react";
import type { VariantProps } from "tailwind-variants";

/**
 * Spinner wrapper **Tailwind Variants** component
 *
 *
 * @example
 * <div className={base())}>
 *    <i className={loader()}/>
 *    <span className={label()}/>
 * </div>
 */
const spinner = tv({
  defaultVariants: {
    color: "default",
    size: "md",
  },
  slots: {
    base: "relative inline-flex flex-col items-center justify-center",
    label: "text-foreground",
    loader: "absolute w-full h-full animate-spin",
    wrapper: "relative flex",
  },
  variants: {
    color: {
      current: {
        loader: "stroke-current",
      },
      danger: { loader: "stroke-danger" },
      default: {
        loader: "stroke-default",
      },
      primary: { loader: "stroke-primary" },
      secondary: { loader: "stroke-secondary" },
      success: {
        loader: "stroke-success",
      },
      warning: { loader: "stroke-warning" },
    },
    size: {
      lg: {
        loader: "stroke-lg!",
        wrapper: "w-10 h-10",
      },
      md: {
        loader: "stroke-md!",
        wrapper: "w-8 h-8",
      },
      sm: {
        loader: "stroke-sm!",
        wrapper: "w-5 h-5",
      },
      xs: {
        loader: "!stroke-xs",
        wrapper: "w-4 h-4",
      },
    },
  },
});

export type SpinnerVariantProps = VariantProps<typeof spinner>;
export type SpinnerSlots = keyof ReturnType<typeof spinner>;

export { spinner };
